import React from 'react';
import * as S from './styled';

const Input = props => (
  <S.Container width={ props.width }>
    <S.Label>{ props.label }</S.Label>
    <S.Input 
      type={ props.type } 
      placeholder={ props.placeholder }
      maxLength={ props.max }
      mask={ props.mask }
      value={ props.value }
      onChange={ props.method }
      border={ props.border }
      disabled={ props.disabled }
    />
  </S.Container>
);

export default Input;